module.exports = __webpack_public_path__ + "media/images/fonts/lg-ff5ab4bf2b54710439f88c36e51da244.eot";